<template>
  <section class="chapter-2">
    <div class="bg-dark upper">
      <FlexWrap>
        <header class="header">
          <div class="container">
            <Year class="year">1850</Year>
            <Title class="title">Ben jij geschikt?</Title>
          </div>
        </header>
        <div class="container">
          <Content>
            <p>Onder druk van de revoluties in Europa besloot koning Willem II plots dat er iets ingrijpend moest veranderen. Hij droeg de liberale staatsman Johan Rudolph Thorbecke op om de grondwet te wijzigen. Ook de verkiezingen moesten op de schop.</p>
          </Content>
        </div>
        <WillemJohanChat />
        <div class="container">
          <Content>
            <p>Het idee: meer mensen moesten invloed krijgen op de politiek. Maar niet zomaar iedereen. Het ging de regering om <i>geschikte</i> mensen. Mannen die meededen in de maatschappij en die belang hadden bij rust en orde.</p>
            <p>Maar ja, hoe bepaal je wie dat zijn?</p>
          </Content>
        </div>
      </FlexWrap>
    </div>
    <OwnedLand />
    <div class="bg-light chapter-2-panel-1" id="after-owned-land">
      <div class="chapter-2-panel-1-wrap">
        <div class="container">
          <Content>
            <p>Wat heeft grond nou met stemmen te maken? Nou, best veel. Want de nieuwe kieswet bepaalde dat je mocht stemmen als je genoeg belasting betaalde. Dat heette het ‘censuskiesrecht’.</p>
          </Content>
          <Floor />
          <Content>
            <p>Wie genoeg grondbelasting betaalde, mocht naar de stembus. Ook andere belastingen speelden een rol. Zo kon je stemrecht krijgen als je belasting betaalde over het aantal deuren en ramen van je huis.</p>
          </Content>
          <Stembus />
        </div>
      </div>
    </div>

    <div class="bg-light chapter-2-panel-2">
      <div class="container">
        <Content class="content">
          <p>Daarmee selecteer je natuurlijk niet per se de meeste geschikte kiezers, dat wisten ze toen ook wel. Maar Thorbecke en co vonden het de minst slechte optie. In 1887 ging die belastinggrens nog iets omlaag en verdubbelde het aantal kiesgerechtigden naar een kwart van alle mannen boven de 23.</p>
        </Content>
        <ArmContract />
        <Content class="content">
          <p>In 1887 kwam ook voor het eerst expliciet in de wet dat alleen mannen mochten stemmen. Dat kwam door feministe Aletta Jacobs. Die was naar de rechter gestapt om kiesrecht te eisen. Die gaf haar toen ongelijk, want kiesrecht voor vrouwen zou niet ‘in de geest der wet’ zijn.</p>
        </Content>
      </div>
    </div>
    <div class="bg-red chapter-2-panel-3">
      <div class="container">
        <Aletta />
        <Accordion track="accordion-leuker-kunnen-we-het-niet-maken">
          <template slot="title">Leuker kunnen we het niet maken...</template>
          <template slot="explanation">
            <p>...wel makkelijker, moet Thorbecke gedacht hebben. Want volgens de nieuwe kieswet was het belastingsysteem de handigste manier om te bepalen welke mannen ‘geschikt’ waren om te stemmen. De gedachte was: als je genoeg belasting betaalde, was dat een ‘teeken eener vermoedelijke bekwaamheid’. Ofwel: je had dan blijkbaar iets bereikt in de maatschappij en daarom had je belang bij een goed bestuur.</p>
            <p>Het belastingsysteem zat in 1850 trouwens wel anders in elkaar dan nu. Belastingen waren niet zozeer gekoppeld aan je inkomen, zoals nu, maar vooral aan je vermogen. Je betaalde belasting over de grond die je bezat, maar bijvoorbeeld ook over het aantal deuren en ramen in je huis en over je dienstboden en paarden, als je die had natuurlijk.</p>
            <p>Daardoor was de groep mannen die mocht stemmen best divers. Er zaten boeren bij met grote lappen grond, maar ook ambachtslieden, zoals bakkers en slagers. Zij konden stemrecht krijgen via een speciale belasting die ze betaalden. Rijke mannen die een etage huurden in de stad mochten juist niet stemmen, omdat ze geen eigen grond bezaten.</p>
          </template>
        </Accordion>
      </div>
    </div>
  </section>
</template>

<script>
import { Year, Title, Content, FlexWrap } from '@/components/chapter'
import WillemJohanChat from './WillemJohanChat'
import OwnedLand from './owned-land'
import ArmContract from './arm-contract'
import Floor from './Floor'
import { chapterMixin } from '@/mixins'
import Accordion from '@/components/Accordion'
import Aletta from './Aletta'
import Stembus from './Stembus'

export default {
  name: 'Chapter2',
  mixins: [chapterMixin],
  components: {
    Year,
    Title,
    Content,
    WillemJohanChat,
    OwnedLand,
    ArmContract,
    Accordion,
    Floor,
    FlexWrap,
    Aletta,
    Stembus
  }
}
</script>

<style lang="scss" scoped>
.upper {
  color: white;
}

.year {
  color: $c-red;
}

.title {
  color: $c-light;
}

.chapter-2-panel-1 {
  padding-top: 100px;

  @media (min-width: 768px) {
    min-height: 100vh;
    padding-top: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.chapter-2-panel-2 {
  overflow: hidden;
  padding-top: 60px;
  padding-bottom: 60px;

  .content {
    position: relative;
    z-index: 2;
  }
}

.chapter-2-panel-3 {
  padding-top: 60px;
}
</style>
